//Libraries
import React from "react";
import { connect } from "react-redux";

// Local Libraries
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { FormInputFile } from "../../../components/SkyFramework/Forms"

//Redux
import { carrierActions } from 'actions';

//Componenets
import { Table } from "../../../components/SkyFramework/Tables/Table.jsx";
import { PaginationBar } from "../../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { LinkButton, OnClickButton } from "../../../components/SkyFramework/Buttons";

//Routes
import { gisRoutes } from "../../../routes/routes";

// Constants
const phrasebook = phrasebookLoad()

class CarrierBulk extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numbers: undefined,
      filters: undefined,
      limit: 10,
      page: 0
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }



  onChangeHandler = event => {
    const file = event.target.files[0];
    this.props.dispatch(carrierActions.addBulk(file, ['xlsx']));
  }


  onClickDownload = event => {
    event.preventDefault();
    this.props.dispatch(carrierActions.downloadTemplate());
  }

  onLoading = () => {
    if (this.props.bulkloading) return <div className="justify-content-center"><span class="spinner"></span></div>
    else return null;
  }

  ShowResults = () => {
    function ifArray(row_errors) {
      var validations = [];
      row_errors.forEach(error => {
        validations.push(<div><pre>Field: {error.field}</pre><pre>{error.message}</pre></div>)
      })
      return validations;
    }
    if (this.props.bulkresults && Array.isArray(this.props.bulkresults)) {
      var view = [];
      this.props.bulkresults.forEach(row => {
        if (row.status === 'created')
          view.push(
            <div class="alert alert-info">
              <pre><b>Row: {row.row}</b></pre>
              Created Successfully
            </div>
          )
        else if (row.status === 'exist') view.push(
          <div class="alert alert-warning">
            <pre><b>Row: {row.row}</b></pre>
            Already exist
            {ifArray(row.errors)}
          </div>
        )
        else view.push(
          <div class="alert alert-error">
            <pre><b>Row: {row.row}</b></pre>
            {ifArray(row.errors)}
          </div>
        )
      })
      return view;
    } else return null;
  }

  render = () => {
    return (<>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.carrier.list, label: phrasebook.headerlinks.carriers }]} current={`${phrasebook.common.bulk} ${phrasebook.headerlinks.carrier}`} />
      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.carriers}</h2>
        <p>{phrasebook.numbers.invnumber_information_description}</p>
        <div className="form-row">
          <div className="d-flex flex-column flex-sm-row align-items-center mb-1">
            {/* <OnClickButton onClick={this.onClickDownload} title={'Download Template'} /> */}

            <div className="ml-sm-auto mt-1 mt-sm-0">
              {this.onLoading()}
              <FormInputFile
                label={"Bulk File"}
                id={"e-input"}
                name={"file"}
                uploadFile={this.onChangeHandler}
                accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"}
              />
            </div>
          </div>
        </div>
        <br />
        <LinkButton title={phrasebook.common.back} link={gisRoutes.management.carrier.list} />

      </div >
      {this.ShowResults()}
    </>);
  }
}

function mapStateToProps(state) {
  const { authentication, carrier } = state;
  const { authUser } = authentication;
  return {
    authUser,
    bulkresults: carrier.bulkresults,
    bulkloading: carrier.bulkloading
  };
}

const carrierbulk = connect(mapStateToProps)(CarrierBulk);
export default carrierbulk;
